import { Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistanceRateConfig extends Layout {
    checkbox53ftTrailer: Checkbox;
    checkboxBorderOpen: Checkbox;
    checkboxHazmatRouting: Checkbox;
    checkboxIntelli102InTrailerWidth: Checkbox;
    checkboxIntelli53ftTrailer: Checkbox;
    checkboxIntelliApplyRoadwork: Checkbox;
    checkboxIntelliAroundConstruction: Checkbox;
    checkboxIntelliCanBorderRestrict: Checkbox;
    checkboxIntelliHazmatRouting: Checkbox;
    checkboxIntelliPhysRestrictions: Checkbox;
    checkboxMileMakerBorderCrossings: Checkbox;
    checkboxMileMakerGuide20Ferries: Checkbox;
    checkboxMileMakerGuide20Highways: Checkbox;
    checkboxMileMakerGuide20Tunnels: Checkbox;
    checkboxMileMakerGuide20UTurns: Checkbox;
    checkboxMileMakerGuide20UnpavedRds: Checkbox;
    checkboxMileMakerTolls: Checkbox;
    checkboxNatNetwork: Checkbox;
    checkboxOvrdRestrictions: Checkbox;
    checkboxTollsDisc: Checkbox;
    checkboxUseCustRoads: Checkbox;
    checkboxUseHwyOnly: Checkbox;
    labelCalcToApplyChanges: Label;
    panelIntellirouteDistanceOptions: Panel;
    panelMileMakerDistanceOptions: Panel;
    panelMileMakerGuide20Checkboxes: Panel;
    panelMileMakerGuide20Options: Panel;
    panelPcMilerDistOptions: Panel;
    sourceDistanceControl: DataSource;
    sourceDistanceProfile: DataSource;
    textboxIntelliTollRoadBias: Textbox;
    textboxIntelliTrailerOptions: Textbox;
    textboxLookupBy: Textbox;
    textboxLookupType: Textbox;
    textboxMileMakerGUide20Weight: Textbox;
    textboxMileMakerGuide20Axles: Textbox;
    textboxMileMakerGuide20DepartAt: Textbox;
    textboxMileMakerGuide20DepartOption: Textbox;
    textboxMileMakerGuide20Height: Textbox;
    textboxMileMakerGuide20HeightIn: Textbox;
    textboxMileMakerGuide20MaxSpeed: Textbox;
    textboxMileMakerGuide20WidthFt: Textbox;
    textboxMileMakerGuide20WidthIn: Textbox;
    textboxMileMakerHazmatTypes: Textbox;
    textboxMileMakerTrailerLength: Textbox;
    textboxMileMakerVehicleType: Textbox;
    textboxServerToUse: Textbox;
    textboxVersion: Textbox;
}
